export const GLOBAL_CONVERSATION_KEY = 'GLOBAL'

const CONVERSATION_MAP_KEY_SEPARATOR = '|'

export type ConversationScope = {
  workspaceId: string | null
  appId: string | null
}

export const getConversationMapKey = (
  { workspaceId, appId }: ConversationScope,
  processId: string | null
): string =>
  [workspaceId ?? '', appId ?? '', processId ?? GLOBAL_CONVERSATION_KEY].join(
    CONVERSATION_MAP_KEY_SEPARATOR
  )
